<template>
    <div class="row darker fs-small font-weight-600">
        <div class="col-sm-6 col-md-6 col-lg-3 d-flex">
            <label class="mr-1">Name:</label>
            <span class="ellipsisLimit">{{name}}</span>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex">
            <label class="mr-1">Country:</label>
            <span>{{country}}</span>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex">
            <label class="mr-1">Phone:</label>
            <span class="ellipsisLimit">{{phone}}</span>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex align-items-top pl-4">
            <label class="mr-1">Seller:</label>

            <span v-if="isResevationSoldByOta">
                {{otaSellerName}}
            </span>
            <span v-else-if="reservation.channelType >= 100 && reservation.channelType <= 102">Widget</span>
            <span v-else-if="canChangeSeller && !reservation.flags.isFullyInvoiced && !isRebookedReservation" class="top-area__seller-picker" >
                <seller-picker
                    size="small"
                    :reservation="reservation"
                    :orignalSeller="reservation.creatorAgent ? reservation.creatorAgent : reservation.creatorUserAccount"
                    @input="sellerChanged"
                    :hideOthers='false'
                    :inlcudeWidget='true'
                    :hideGetYourGuide='true'
                    :hideViator='true'
                    :hideAllByChannel="true">
                </seller-picker>
            </span>
            <span v-else>
                {{ reservation.creatorAgent ? reservation.creatorAgent.brandName : reservation.creatorUserAccount ? (reservation.creatorUserAccount.name || reservation.creatorUserAccount.label) : '' }}
            </span>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex">
            <label class="mr-1">Email:</label>
            <span class="ellipsisLimit" v-tooltip="email">{{email}}</span>
        </div>

        <div v-if="getOrigins.length !== 0" class="col-sm-6 col-md-6 col-lg-3 d-flex align-items-top" v-tooltip="origin">
            <label class="mr-1 d-flex">
                <span v-if="originsRequired" style="color: red;">*</span>
                Origin:
            </label>

            <v-select
                class="top-area__dropdown"
                :class="{'top-area__dropdown--error': originsRequired && !reservation.originId}"
                style="max-width: 80% !important; border-radius: 5px;"
                :options="originsOptions"
                label="name" v-model="selectedOrigin" placeholder="- Select origin -" @input="updateOrigin"
            ></v-select>
        </div>

        <div v-if="getSegments.length !== 0" class="col-sm-6 col-md-6 col-lg-3 d-flex">
            <label class="mr-1 d-flex">
                <span v-if="segmentsRequired" style="color: red;">*</span>
                Segment:
            </label>

            <v-select
                class="top-area__dropdown"
                :class="{'top-area__dropdown--error': segmentsRequired && !reservation.segmentId}"
                style="max-width: 80% !important;border-radius: 5px; "
                :options="segmentsOptions"
                label="name" v-model="selectedSegment" placeholder="- Select Segment -" @input="updateSegment"
            ></v-select>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex align-items-top pl-4" v-tooltip="{content: notes, classes: 'max-width'}">
            <label class="mr-1">Notes:</label>

            <span v-if="notes" class="ellipsisLimit">{{notes}}</span>
            <span v-else class="dark">No notes</span>
        </div>

        <div class="col-sm-6 col-md-6 col-lg-3 d-flex align-items-top"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventMixin } from '@/mixins/event'

import SellerPicker from '../../SellerPicker'
import extendedVSelect from '@/extends/vue-select'

export default {
    mixins: [
        eventMixin
    ],
    data() {
        return {
            selectedOrigin: {
				name: 'None',
				id: 0
			},
            selectedSegment: {
				name: 'None',
				id: 0
			},
        }
    },
    async mounted() {
        await this.setDefaults();
    },
    props: {
        reservation: {
            type: Object
        },
    },
	watch: {
		'reservation': {
			handler(newVal, oldVal) {
				this.$emit('topAreaIsReadyToSubmit', this.isReadyToSubmit);
			},
			deep: true,
			immediate: true,
		},
	},
    computed: {
        ...mapGetters([
            'getOrigins',
            'getSegments',
			'getCompanySettings',
            'getAllIntegrations'
        ]),
        isRebookedReservation() {
            const rebookedStatus = [20, 21, 30];
            
            return rebookedStatus.includes(this.reservation.status);
        },
		originsOptions() {
			const emptyOrigin = { name: 'None', id: 0 };
			const origins = this.getOrigins;

            // If required, don't allow None selection
			if (this.originsRequired) return origins; 

			return [emptyOrigin, ...origins];
		},
		segmentsOptions() {
			const emptySegment = { name: 'None', id: 0 };
			const segments = this.getSegments;

            // If required, don't allow None selection
			if (this.segmentsRequired) return segments; 

			return [emptySegment, ...segments];
		},
		originsRequired() {
			return this.getCompanySettings.settingsPresets && this.getCompanySettings.settingsPresets.isOriginRequired;
		},
		segmentsRequired() {
			return this.getCompanySettings.settingsPresets && this.getCompanySettings.settingsPresets.isSegmentRequired;
		},
		isReadyToSubmit() {
			if (this.originsRequired && this.originsOptions.length !== 0 && !this.reservation.originId) return false;
			if (this.segmentsRequired && this.segmentsOptions.length !== 0 && !this.reservation.segmentId) return false;
			
            return true;
		},
        isResevationSoldByOta() {
            return this.reservation.channelType > 200 && this.getAllIntegrations.some(possibleOta => possibleOta.integration == this.reservation.channelType);
        },
        otaSellerName() {
            if (this.isResevationSoldByOta) {
                const ota = this.getAllIntegrations.find(possibleOta => possibleOta.integration == this.reservation.channelType && possibleOta.channelId === this.reservation.channelId);
                
                return ota ? ota.label : '';
            } else {
                return null;
            }
        },
        name() {
            return this.reservation.customer.name? this.reservation.customer.name : '-';
        },
        country() {
            return this.reservation.customer.countryName? this.reservation.customer.countryName : '-';
        },
        phone() {
            return this.reservation.customer.phone || '-';
        },
        email() {
            return this.reservation.customer.email? this.reservation.customer.email : '-';
        },
        notes() {
            return this.reservation.note ? this.reservation.note : null;
        },
        origin() {
            return this.reservation.origin ? this.reservation.origin : null;
        },
        segment() {
            return this.reservation.segment ? this.reservation.segment : null;
        },
        canChangeSeller() {
            return this.accessPermissionFilter(['admin', 'supervisor']);
        },
    },
    methods: {
        ...mapActions([
            'setReservationCalculations',
            'resetCalculationsGuid',
            'openReservationById',
            'closeModal'
        ]),
        setDefaults() {
			this.selectedOrigin.name = !!this.reservation.origin ? this.reservation.origin : 'None';
			this.selectedOrigin.id = !!this.reservation.originId ? this.reservation.originId : null;

			this.selectedSegment.name = !!this.reservation.segment ? this.reservation.segment : 'None';
			this.selectedSegment.id = !!this.reservation.segmentId ? this.reservation.segmentId : null;
        },
        sellerChanged(newSeller) {
            this.$set(this.reservation.updateFlags, 'reservation', true);
            this.resetCalculationsGuid();
            
            this.reservation.calculationsGUID = null;

            this.$set(this.reservation, 'currentChannelCommission', {
                isToOverwriteComponent: false,
                isToOverwriteProduct: false,
            });

            this.setReservationCalculations(this.reservation).then(response => {
                this.$set(this.reservation, 'currentChannelCommission', response.data.currentChannelCommission);
            });

            this.reservation.updateFlags.reservation = true;
        },
        updateOrigin(chosen) {
			this.$set(this.reservation.updateFlags, 'reservation', true);

            if (chosen) {
                this.reservation.originId = chosen.id === 0 ? null : chosen.id;
                this.reservation.origin = chosen.name;
            }
        },
        updateSegment(chosen) {
			this.$set(this.reservation.updateFlags, 'reservation', true);

            if (chosen) {
                this.reservation.segmentId = chosen.id === 0 ? null : chosen.id;
                this.reservation.segment = chosen.name;
            }
        },
    },
    components: {
        SellerPicker,
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss">
    @import '../../../assets/scss/_variables.scss';
    @import '../../../assets/scss/_utility.scss';
    
    .ellipsisLimit {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .dropdown.v-select.top-area__dropdown {
        &--error {
            .dropdown-toggle {
                border: 1px solid #e73f47;
            }
        }

        .dropdown-toggle {
            height: 1.5rem !important;

            .vs__actions {
                top: 3px !important;
            }

            .selected-tag, & input[type=search] {
                height: 1.4rem !important;
                margin: 0 !important;
                line-height: 1.4rem !important;
            }
        }

        .open-indicator {
            height: 14px !important;
        }
    }

    .top-area__seller-picker {
        z-index: 3;
        width: 100%;
        
        .seller-picker {
            .multiselect {
                border: none !important;
                background: none !important;
                padding: 0 !important;

                .multiselect__tags{
                    .multiselect__single, .multiselect__input {
                        @extend .radius-normal;
                        @extend .border-light;
                        
                        padding: 0 0.5rem;
                    }
                }

                .multiselect__select {
                    height: 100%;
                    width: auto;

                    &:before{
                        top: -4px;
                    }
                }
            }
        }
    }

    .max-width {
        max-width: 40vw;
    }
</style>



// WEBPACK FOOTER //
// TopArea.vue?b02faf22